import React from "react";
import {
  ToggleContainer,
  ToggleLabel,
  ToggleSwitch,
  ToggleSlider,
  ToggleInput,
} from "./StatusToggle.styles";

interface StatusToggleProps {
  showCompleted: boolean;
  onChange: (showCompleted: boolean) => void;
}

export function StatusToggle({ showCompleted, onChange }: StatusToggleProps) {
  return (
    <ToggleContainer>
      <ToggleLabel $active={!showCompleted}>To Do</ToggleLabel>
      <ToggleSwitch>
        <ToggleInput
          style={{ display: "none" }}
          type="checkbox"
          checked={showCompleted}
          onChange={(e) => onChange(e.target.checked)}
        />
        <ToggleSlider />
      </ToggleSwitch>
      <ToggleLabel $active={showCompleted}>Done</ToggleLabel>
    </ToggleContainer>
  );
}
